import React from 'react';
import { useNavigate } from 'react-router';
import { useTranslate } from '../../mixins/translate/translate';
import { openApiFetchGet } from '../../store/openApiFetch';
import { Roles } from '../../utils/enums/Roles';
import { Table, TableBody, TableData, TableHead, TableHeader, TableHeadRow, TableRow, PanelBody, PanelWithoutForm, PanelHeading } from '../elements';
import { Spinner } from '../spinners';
import { useUserHasRole } from '../utils/authorization/useUserHasRole';
import { EquipmentExpirationLabel } from '../utils/equipmentExpirationLabel';
import { NullableFormattedDate } from '../utils/NullableFormattedDate';
import { useReactAsync } from '../utils/useReactAsync';

async function loadEquipment() {
    const result = await openApiFetchGet('/api/equipmentExpirations', {});
    return result;
}

export function DashboardEquipmentExpirations() {
    const translate = useTranslate();
    const { userHasRole } = useUserHasRole();
    const isAdmin = userHasRole([Roles.Administrator]);
    const { data, isLoading } = useReactAsync(loadEquipment, {}, []);
    const navigate = useNavigate();

    if (isLoading) {
        return <Spinner />;
    }

    if (data?.length === 0) {
        return null;
    }

    return (
        <PanelWithoutForm>
            <PanelHeading icon="fa fa-briefcase" text={translate('equipment.expireSoon')} />
            <PanelBody noPadding={true}>
                <Table hover={true}>
                    <TableHead>
                        <TableHeadRow light={true}>
                            <TableHeader>{translate('common.name')}</TableHeader>
                            <TableHeader>{translate('common.type')}</TableHeader>
                            {isAdmin && (
                                <>
                                    <TableHeader>{translate('common.company')}</TableHeader>
                                </>
                            )}
                            <TableHeader>{translate('common.status')}</TableHeader>
                            <TableHeader>{translate('equipment.expirationDate')}</TableHeader>
                            <TableHeader align="right">{translate('equipment.expiresIn')}</TableHeader>
                        </TableHeadRow>
                    </TableHead>
                    <TableBody>
                        {data &&
                            data.map((item) => (
                                <TableRow key={item.id} onClick={() => navigate(`/equipment/${item.id}`)}>
                                    <TableData> {item.name} </TableData>
                                    <TableData> {item.equipmentType.name} </TableData>
                                    {isAdmin && (
                                        <>
                                            <TableData>{item.clientCompany.name}</TableData>
                                        </>
                                    )}
                                    <TableData> {translate(`equipment.${item.status}`)}</TableData>
                                    <TableData>
                                        {' '}
                                        <NullableFormattedDate value={item.dateEndCertificateValidity} />
                                    </TableData>
                                    <TableData alignRight>
                                        {' '}
                                        <EquipmentExpirationLabel data={item} showDays={true} />
                                    </TableData>
                                </TableRow>
                            ))}
                    </TableBody>
                </Table>
            </PanelBody>
        </PanelWithoutForm>
    );
}
